import { ValidationErrorKey } from "../../validators/general-validation.";
import { ControlType, FormField } from "../base";

export class FormFieldInput extends FormField {
  public override controlType = ControlType.INPUT;

  public inputPrefix?: string | undefined;
  public inputSuffix?: string | undefined;

  public inputType?: HtmlInputType;
  public inputMode?: HtmlInputMode;
  public placeholder?: HTMLInputElement["placeholder"];

  public inputHtmlAttributes: InputHtmlAttribute[] = [];

  public autoComplete?: InputAutoCompleteAttribute;

  constructor(init: InputFormFieldInit<FormFieldInput>) {
    super(init);

    this.inputType = init.inputType ?? HtmlInputType.TEXT;
    this.placeholder = init.placeholder ?? "";
    this.inputPrefix = init.inputPrefix;
    this.inputSuffix = init.inputSuffix;
    this.autoComplete = init.autoComplete ?? InputAutoCompleteAttribute.OFF;
    this.inputMode = init.inputMode ?? HtmlInputMode.TEXT;

    super.addErrorMessages({
      [ValidationErrorKey.REQUIRED]: $localize`${init.label}:Input label: ist ein Pflichtfeld.`,
    });
  }

  protected addInputHtmlAttribute(key: string, value: string) {
    this.inputHtmlAttributes.push({ key, value });
  }
}

interface InputHtmlAttribute {
  key: string;
  value: string;
}

export enum HtmlInputType {
  BUTTON = "button",
  CHECKBOX = "checkbox",
  COLOR = "color",
  DATE = "date",
  DATE_TIME_LOCAL = "datetime-local",
  EMAIL = "email",
  FILE = "file",
  HIDDEN = "hidden",
  IMAGE = "image",
  MONTH = "month",
  NUMBER = "number",
  PASSWORD = "password",
  RADIO = "radio",
  RANGE = "range",
  RESET = "reset",
  SEARCH = "search",
  SUBMIT = "submit",
  TEL = "tel",
  TEXT = "text",
  TIME = "time",
  URL = "url",
  WEEK = "week",
}

// https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode
export enum HtmlInputMode {
  NONE = "none",
  TEXT = "text",
  DECIMAL = "decimal",
  NUMERIC = "numeric",
  TEL = "tel",
  SEARCH = "search",
  EMAIL = "email",
  URL = "url",
}

// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
export enum InputAutoCompleteAttribute {
  BIRTHDAY_DAY = "bday-day",
  BIRTHDAY_MONTH = "bday-month",
  BIRTHDAY_YEAR = "bday-year",
  GIVEN_NAME = "given-name",
  LAST_NAME = "family-name",
  EMAIL = "email",
  USERNAME = "username",
  STREET_ADDRESS = "street-address",
  POSTAL_CODE = "postal-code",
  CITY_NAME = "address-level2",
  TELEPHONE_NUMBER = "tel",
  OFF = "off",
}

export type InputFormFieldInit<T> = Omit<
  T,
  "inputHtmlAttributes" | "controlType" | "updateFormControlOn"
>;
